import React, { useState } from 'react';
import compose from 'recompose/compose';
import { set as lsSet } from 'local-storage';
import {
  FormControl,
  Grid,
  MenuList,
  MenuItem,
  Typography,
  Button,
  Popper,
  Paper,
  Grow,
  ClickAwayListener,
  Modal,
  Link,
} from '@mui/material';
import { Link as DomLink, Switch, Route } from 'react-router-dom';
import { windowFeatureIsEnabled } from 'config/window-features';
import { UserPermissions } from 'interfaces/user/Permissions';
import withStyles from '@mui/styles/withStyles';
import { DropdownIcon } from 'components/icons/icons';
import { ROUTES } from 'constants/index';
import { UserUtils } from 'utils/user-utils';
import { getNextTheme, switchTheme } from 'lib/themes/util';
import { getCustomerIdFromLocation } from 'helpers/router';
import { styles } from './dropdown-styles';

const UserDropdown = props => {
  const { classes } = props;

  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const canSeeAppManager = UserUtils.userIsPermitted(
    UserPermissions.ApplicationManagerAccess,
    getCustomerIdFromLocation(),
  );

  const nextTheme = getNextTheme();
  const handleClick = e => {
    setAnchorEl(e.currentTarget);
    setOpen(!open);
  };

  return (
    <>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <div className={classes.modal}>
          <Grid item xs={12} className={classes.modalText}>
            <Grid container alignItems="center">
              <Typography>
                {`${'To submit Arbor related defect or support request please email '} `}
                <Link href="mailto:arborsupport@cps.com" underline="always">
                  arborsupport@cps.com
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.modalText}>
            <Grid container alignItems="center">
              <Typography>
                {`${'To submit Arbor Invoicing related defect or support request please email '} `}
                <Link href="mailto:invoicingsupport@cps.com" underline="always">
                  invoicingsupport@cps.com
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.modalText}>
            <Grid container alignItems="center">
              <Typography>
                {`${'To submit analytics relates defect or support request please email '} `}
                <Link href="mailto:analyticssupport@cps.com" underline="always">
                  analyticssupport@cps.com
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </div>
      </Modal>
      <form autoComplete="off">
        <FormControl className={classes.formControl}>
          <Grid container direction="row">
            <Grid item>
              <Grid container direction="column" alignItems="flex-end">
                <Typography variant="caption" className={classes.label}>
                  User
                </Typography>
                <Typography variant="body2">
                  {window.USER ? window.USER.username : 'Loading ...'}
                </Typography>
              </Grid>
            </Grid>

            <Grid item>
              <Button
                className={classes.dropdownButton}
                aria-owns={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <DropdownIcon />
              </Button>
              <Popper
                open={open}
                anchorEl={anchorEl}
                transition
                disablePortal
                placement="bottom-end"
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    id="menu-list-grow"
                    style={{
                      transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener
                        onClickAway={() => {
                          setOpen(false);
                        }}
                      >
                        <MenuList>
                          <MenuItem
                            onClick={() => {
                              setOpenModal(true);
                            }}
                          >
                            <Typography className={classes.listItem}>
                              Submit Defect/Support Request
                            </Typography>
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              setOpen(false);
                              window.open(
                                // eslint-disable-next-line max-len
                                'https://trellisrx.atlassian.net/servicedesk/customer/portal/3/group/10',
                              );
                            }}
                          >
                            <Typography className={classes.listItem}>
                              Submit an Enhancement
                            </Typography>
                          </MenuItem>

                          <MenuItem
                            onClick={() => {
                              setOpen(false);
                              switchTheme();
                            }}
                          >
                            <Typography className={classes.listItem}>
                              Switch to {nextTheme}
                            </Typography>
                          </MenuItem>

                          <Switch>
                            <Route path={ROUTES.APPLICATION_MANAGER}>
                              <MenuItem component={DomLink} to="/" onClick={() => setOpen(!open)}>
                                <Typography className={classes.listItem}>Arbor</Typography>
                              </MenuItem>
                            </Route>
                            {canSeeAppManager && (
                              <Route path="/">
                                <MenuItem
                                  component={DomLink}
                                  to={`${ROUTES.APPLICATION_MANAGER}/gtd/global-gtd`}
                                  onClick={() => setOpen(!open)}
                                >
                                  <Typography className={classes.listItem}>
                                    Application Manager
                                  </Typography>
                                </MenuItem>
                              </Route>
                            )}
                          </Switch>

                          <MenuItem
                            onClick={() => {
                              lsSet('logout_signal', true);
                            }}
                          >
                            <Typography className={classes.listItem}>Logout</Typography>
                          </MenuItem>
                          {windowFeatureIsEnabled('user_guide') && (
                            <MenuItem
                              onClick={() => {
                                window.open('/user-guide/', '_blank');
                              }}
                            >
                              <Typography className={classes.listItem}>User Guide</Typography>
                            </MenuItem>
                          )}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </Grid>
          </Grid>
        </FormControl>
      </form>
    </>
  );
};

export default compose(withStyles(styles, { withTheme: true }))(UserDropdown);
